import { render, staticRenderFns } from "./settingCleanStaffHisPopup.vue?vue&type=template&id=06c0a78c&scoped=true"
import script from "./settingCleanStaffHisPopup.vue?vue&type=script&lang=js"
export * from "./settingCleanStaffHisPopup.vue?vue&type=script&lang=js"
import style0 from "./settingCleanStaffHisPopup.vue?vue&type=style&index=0&id=06c0a78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0a78c",
  null
  
)

export default component.exports